import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import uniqBy from 'lodash.uniqby';
import { CouponStatus } from '@constants/coupons';
import { useLocations } from './useLocations';

export const useCouponsTemplates = () => {
    const coupons = useSelector(state => state.coupons.dataAll);
    const { locationsMap } = useLocations();

    const mapTemplatePropsToOption = coupon => ({
        value: coupon.id,
        label: coupon.title,
    });

    const getCouponsOptions = useCallback(() => {
        return coupons.filter(coupon => coupon.status === CouponStatus.Active).map(mapTemplatePropsToOption);
    }, [coupons]);

    const getCouponsOptionsByLocationsId = (locationId, propsMapper = mapTemplatePropsToOption) => {
        const brandId = locationsMap[locationId]?.brand?.id;
        const matchingCoupons = coupons.filter(coupon => {
            if (coupon.status !== CouponStatus.Active) return false;

            const matchesLocation = coupon.locationId && coupon.locationId === locationId;
            const matchesBrand = !coupon.locationId && coupon.brandId && coupon.brandId === brandId;
            return matchesLocation || matchesBrand;
        });

        return uniqBy(matchingCoupons.map(propsMapper), 'value');
    };

    const getCouponsOptionsByBrandId = (brandId, propsMapper = mapTemplatePropsToOption) => {
        if (!brandId) return [];
        const matchingCoupons = coupons.filter(
            coupon => coupon.status === CouponStatus.Active && coupon.brandId === brandId && !coupon.locationId,
        );
        return uniqBy(matchingCoupons.map(propsMapper), 'value');
    };

    return {
        getCouponsOptionsByLocationsId,
        getCouponsOptionsByBrandId,
        getCouponsOptions,
    };
};
